module.exports = __webpack_public_path__ + "static/3_2_Bayes-Rule_2_SL-854722513a5554a580dcf89993663839.svg";